import { CalendarClock, Languages, MessageCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function Features() {
    const { t } = useTranslation();
    return (
        <section id="features" className="landing-section landing-features" aria-labelledby="features-title">
            <div className="landing-container">
                <div className="landing-section-heading landing-centered">
                    <p className="landing-eyebrow">{t('features.badge')}</p>
                    <h2 id="features-title">{t('features.title')}</h2>
                    <p>{t('features.subtitle')}</p>
                </div>
                <div className="landing-feature-grid">
                    <article className="landing-personal-card">
                        <MessageCircle size={25} strokeWidth={1.5} aria-hidden="true" />
                        <h3>{t('features.questions.title')}</h3>
                        <p>{t('features.questions.desc')}</p>
                        <div className="landing-question-example">
                            <span className="landing-mini-label">{t('features.questions.label')}</span>
                            <blockquote>{t('features.questions.example')}</blockquote>
                            <span className="landing-question-note">{t('features.questions.note')}</span>
                        </div>
                    </article>
                    <article className="landing-feature-card">
                        <Languages size={25} strokeWidth={1.5} aria-hidden="true" />
                        <h3>{t('features.languages.title')}</h3>
                        <p>{t('features.languages.desc')}</p>
                        <div className="landing-language-list"><span lang="en">Hello, how are you?</span><span lang="es">Hola, ¿cómo estás?</span><span lang="zh">你好，今天怎么样？</span></div>
                    </article>
                    <article className="landing-feature-card">
                        <CalendarClock size={25} strokeWidth={1.5} aria-hidden="true" />
                        <h3>{t('features.schedule.title')}</h3>
                        <p>{t('features.schedule.desc')}</p>
                        <div className="landing-schedule-example"><span>{t('features.schedule.label')}</span><strong>{t('features.schedule.time')}</strong><span>{t('features.schedule.note')}</span></div>
                    </article>
                </div>
            </div>
        </section>
    );
}
